// Lookup Tool compare: keep the viewer in place across the reload.
//
// Selecting OR clearing a comparison parish does a full server reload, which would otherwise
// dump the viewer at the top of the page. We bring them back to the compare/chart area WITHOUT
// a #fragment in the URL (so shared ?comparisonId= links stay clean): flag the click in
// sessionStorage, then scroll to #parish-in-detail on the next load and clear it. Only an active
// selection/clear scrolls — opening a shared link keeps the normal top-of-page view.

const compareScrollFlagKey = "cufCompareScroll";

// A compare selection is any link that adds ?comparisonId=; clearing (the pill's ✕, which
// links back to the param-less URL) is tagged with data-parish-compare-scroll.
document.addEventListener("click", (event) => {
  if (event.target.closest('a[href*="comparisonId="], a[data-parish-compare-scroll]')) {
    sessionStorage.setItem(compareScrollFlagKey, "1");
  }
});

if (sessionStorage.getItem(compareScrollFlagKey)) {
  sessionStorage.removeItem(compareScrollFlagKey);
  const parishCompareAnchor = document.getElementById("parish-in-detail");
  if (parishCompareAnchor) parishCompareAnchor.scrollIntoView();
}
